/**
 * @typedef {Object} GumMatrixDO
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} stageNumber - The stage number
 * @property {Matrix4} gumMatrix - The gum matrix list
 */

import { TOOTH_GUM_TYPE_KEY, TOOTH_STAGE_NUMBER_KEY } from "../constant/toothConstant";

/**
 * @type {GumMatrixDO[]}
 */
const gumMatrixDOListSingle = [];
const gumMatrixDOMapSingle = {};

/**
 * @param {GumMatrixDO} gumMatrixDO
 */
const addGumMatrixDO = (gumMatrixDO) => {
  gumMatrixDOListSingle.push(gumMatrixDO);
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${gumMatrixDO.stageNumber}.${TOOTH_GUM_TYPE_KEY}:${gumMatrixDO.toothGumType}`
  gumMatrixDOMapSingle[key] = gumMatrixDO;
};

const getGumMatrixDOList = () => {
  return gumMatrixDOListSingle;
};

const getGumMatrixDOByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}`
  const gumMatrixDO = gumMatrixDOMapSingle[key];
  return gumMatrixDO
};

export default {
  addGumMatrixDO,
  getGumMatrixDOList,
  getGumMatrixDOByStageNumberAndToothGumType
};
